import clsx from 'clsx'
import Icon from './svg/icon'
import { Fragment } from 'react'
import Link from 'next/link'

type Props = {
	theme: 'light' | 'dark'
	breadcrumbs: {
		label: string
		href?: string
	}[]
	className?: string
	isNewsArticle?: boolean
}

export default function Breadcrumbs({ theme, breadcrumbs, className, isNewsArticle }: Props) {
	return (
		<div
			className={clsx(
				'flex flex-wrap items-center gap-2 text-xs uppercase mt-8',
				theme === 'dark' ? 'text-white fill-white' : 'text-blue-dark fill-blue-dark',
				className
			)}
		>
			<Link
				href="/"
				className="relative rounded-md z-0 before:content-[''] before:absolute before:inset-0 before:bg-white before:rounded-sm before:opacity-0 before:pointer-events-none before:-z-10 hover:before:opacity-100 before:transition-opacity before:duration-300"
				aria-label="Home"
			>
				<Icon icon="Home" className={clsx(theme === 'dark' && 'fill-white')} />
			</Link>

			<Icon icon="ChevronBold" className={clsx('w-3', isNewsArticle ? 'text-blue' : '')} />
			{breadcrumbs?.map(({ label, href }, index) => {
				if (href) {
					return (
						<Fragment key={`${href}-${index}`}>
							<a
								href={href}
								className="relative rounded-md z-0 before:content-[''] before:absolute before:inset-y-0 before:-inset-x-1 before:bg-white before:rounded-sm before:opacity-0 before:pointer-events-none before:-z-10 hover:before:opacity-100 before:transition-opacity before:duration-300"
							>
								{label}
							</a>
							<Icon icon="ChevronBold" className={clsx('w-3', isNewsArticle ? 'text-blue' : '')} />
						</Fragment>
					)
				} else {
					return <span key={`${label}-${index}`}>{label}</span>
				}
			})}
		</div>
	)
}
